"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventStatuses = exports.EventTypes = exports.SocialLinkNames = exports.getVisibilityRuleStates = exports.UserEventStates = void 0;
var UserEventStates;
(function (UserEventStates) {
    UserEventStates[UserEventStates["draft"] = 0] = "draft";
    UserEventStates[UserEventStates["submitted"] = 1] = "submitted";
    UserEventStates[UserEventStates["registered"] = 2] = "registered";
})(UserEventStates = exports.UserEventStates || (exports.UserEventStates = {}));
const getVisibilityRuleStates = (rules) => {
    if (Array.isArray(rules.states)) {
        return rules.states;
    }
    return [];
};
exports.getVisibilityRuleStates = getVisibilityRuleStates;
exports.SocialLinkNames = [
    "facebook",
    "instagram",
    "tiktok",
    "spotify",
    "youtube",
    "twitter",
    "shazam",
];
var EventTypes;
(function (EventTypes) {
    EventTypes[EventTypes["Swiper"] = 0] = "Swiper";
    EventTypes[EventTypes["Round"] = 1] = "Round";
    EventTypes[EventTypes["Cards"] = 2] = "Cards";
    EventTypes[EventTypes["Boxy"] = 3] = "Boxy";
    EventTypes[EventTypes["Grunge"] = 4] = "Grunge";
})(EventTypes = exports.EventTypes || (exports.EventTypes = {}));
exports.EventStatuses = [
    "published",
    "unpublished",
    "deleted",
    "demo",
    "draft",
];
//# sourceMappingURL=event.js.map